module.exports = __webpack_public_path__ + "img/sankaku_46_blue.52afeaee.png";